import { render } from "./AdminVacanciesView.vue?vue&type=template&id=41c1b9ec&scoped=true&ts=true"
import script from "./AdminVacanciesView.vue?vue&type=script&lang=ts"
export * from "./AdminVacanciesView.vue?vue&type=script&lang=ts"

import "@/assets/admin-crud.css?vue&type=style&index=0&id=41c1b9ec&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c1b9ec"]])

export default __exports__